import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'

import httpClient from '../httpClient'
import { apiErrorMessage } from '../lib/utils'

import Loading from '../components/common/Loading'
import OrderSummary from '../components/LabOrderSummary/OrderSummary'
import OrderCheckout from '../components/LabOrderSummary/OrderCheckout'

const LabOrderSummaryPage = () => {
  const { id } = useParams()
  const [order, setOrder] = useState(null)
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState(false)

  useEffect(() => {
    (async () => {
      setLoading(true)
      try {
        const data = await httpClient(`lab_orders/${id}`)
        setOrder(data)
        setLoading(false)
      } catch (error) {
        setApiError(apiErrorMessage(error))
        setLoading(false)
      }
    })()
  }, [id])

  const handleUpdateQuantity = useCallback(
    async (guid, quantity) => {
      try {
        await httpClient.patch(`line_items/${guid}/update_quantity`, {
          line_items: [{ quantity }],
        })
        const res = await httpClient(`lab_orders/${id}`)
        setOrder(res)
      } catch (error) {
        setApiError(apiErrorMessage(error))
      }
    },
    [id],
  )

  const handleUpdateMultiOpeningQty = useCallback(
    async (guid, quantity) => {
      try {
        await httpClient.patch(`lab_orders/${id}/multi_openings_line_items/${guid}/update_quantity`, {
          line_items: [{ quantity }],
        })
        const res = await httpClient(`lab_orders/${id}`)
        setOrder(res)
      } catch (error) {
        setApiError(apiErrorMessage(error))
      }
    },
    [id],
  )

  const handleDelete = useCallback(
    async (guid) => {
      setLoading(true)
      try {
        await httpClient.delete(`line_items/${guid}`)
        const res = await httpClient(`lab_orders/${id}`)
        setOrder(res)
        setLoading(false)
      } catch (error) {
        setApiError(apiErrorMessage(error))
        setLoading(false)
      }
    },
    [order],
  )

  const handleDeleteAlbum = useCallback(
    async (albumGuid) => {
      if (!albumGuid) return
      setLoading(true)
      try {
        await httpClient.delete(`lab_orders/${id}/albums/${albumGuid}`)
        const res = await httpClient(`lab_orders/${id}`)
        setOrder(res)
        setLoading(false)
      } catch (error) {
        setApiError(apiErrorMessage(error))
        setLoading(false)
      }
    },
    [order, id],
  )

  const handleDeleteMultiOpening = useCallback(
    async (guid) => {
      if (!guid) return
      setLoading(true)
      try {
        await httpClient.delete(`lab_orders/${id}/multi_openings_line_items/${guid}`)
        const res = await httpClient(`lab_orders/${id}`)
        setOrder(res)
        setLoading(false)
      } catch (error) {
        setApiError(apiErrorMessage(error))
        setLoading(false)
      }
    },
    [order, id],
  )

  if (loading) {
    return <Loading message="Loading order" />
  }

  if (!id || apiError || !order) {
    return null
  }

  return (
    <div className="container-order-review">
      <div className="w-layout-grid grid-67">
        <OrderSummary
          lineItems={order?.included}
          onUpdateQty={handleUpdateQuantity}
          onUpdateMultiOpeningQty={handleUpdateMultiOpeningQty}
          onDelete={handleDelete}
          onDeleteAlbum={handleDeleteAlbum}
          onDeleteMultiOpening={handleDeleteMultiOpening}
        />
        <OrderCheckout order={order?.data} cartCount={order?.included?.length ?? 0} />
      </div>
    </div>
  )
}

export default LabOrderSummaryPage
